'use strict';

module.exports = require('./Autosuggest').default;


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/react-autosuggest/dist/index.js
// module id = 607
// module chunks = 0